<template>
  <div>
    <div class="va-row">
      <div class="flex md12 xs12">
        <vuestic-widget>
          <vuestic-data-table
            class="text-center"
            :apiMode="true"
            :apiUrl="apiUrl"
            :httpOptions="httpOptions"
            :tableFields="tableFieldsModel"
            :itemsPerPage="itemsPerPage"
            :itemsPerPageLabel="$t('tables.dataTable.perPage')"
            :filterInputLabel="$t('tables.dataTable.search')"
            :defaultPerPage="defaultTablePerPage"
            :sortFunctions="sortFunctions"
            :paginationPath="paginationPath"
            :queryParams="queryParams"
            :reloadTable="reloadTable"
            :additionalActions="true"
          >
            <template slot="additionalTableControl">
              <button
                @click="toggleColumns"
                class="btn btn-micro btn-warning filter-toggle mx-2"
              >
                {{ $t(filterText) }}
              </button>
              <router-link
                class="btn btn-micro btn-primary"
                :to="{ name: 'customer-create' }"
              >
                <i class="ion-md-add ion"></i> {{ $t('buttons.create') }}
              </router-link>
            </template>
          </vuestic-data-table>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Customers',
  data() {
    return {
      httpOptions: {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('cTok') }
      },
      apiUrl: `${process.env.VUE_APP_WEBSITE_URL}api/v1/customers/customer/sub/customers/children`,
      customersErrors: null,
      tableFields: [],
      tableFieldsModel: [],
      reloadTable: false,
      filterText: 'tables.dataTable.filterTextAll',
      sortFunctions: {
        name: function(item1, item2) {
          return item1 >= item2 ? 1 : -1
        },
        email: function(item1, item2) {
          return item1 >= item2 ? 1 : -1
        },
        customer_type: function(item1, item2) {
          return item1 >= item2 ? 1 : -1
        }
      },
      queryParams: {
        sort: 'sort',
        page: 'page',
        perPage: 'per_page'
      },
      itemsPerPage: [
        {
          value: 10
        },
        {
          value: 25
        },
        {
          value: 50
        },
        {
          value: 100
        }
      ],
      paginationPath: '',
      defaultTablePerPage: 10
    }
  },
  methods: {
    toggleColumns() {
      if (this.tableFieldsModel.length == 6) {
        this.tableFieldsModel = this.tableFields
        this.filterText = 'tables.dataTable.filterText'
      } else {
        this.tableFieldsModel = this.tableFields.slice(0, 6)
        this.filterText = 'tables.dataTable.filterTextAll'
      }
      this.refreshTable()
    },
    refreshTable() {
      this.reloadTable = false
      setTimeout(() => {
        this.reloadTable = true
      }, 0)
    }
  },
  async created() {
    this.tableFields = await this.$store.dispatch('customerFields')
    this.tableFields = [
      {
        name: '__sequence',
        dataClass: 'text-light'
      },
      ...this.tableFields
    ]
    this.tableFieldsModel = this.tableFields.slice(0, 6)
    this.refreshTable()
  }
}
</script>
